// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| USUARIOS MENU ITEMS ||============================== //

const usuario = {
    id: 'usuario',
    title: 'Usuarios',
    type: 'group',
    children: [
        {
            id: 'usuarios',
            title: 'Usuarios',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'nuevo_usuario',
                    title: 'Nuevo Usuario',
                    type: 'item',
                    url: '/countable/new-user/0'
                },
                {
                    id: 'lista_usuarios',
                    title: 'Lista Usuarios',
                    type: 'item',
                    url: '/countable/list-user'
                },                
            ]
        },
        
    ]
};

export default usuario;